import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '../screens/company/SettingsLayout';

/** Company settings: a rail of areas, one screen each. */
export const Route = createFileRoute('/t/$tenant/settings')({
  component: SettingsLayout,
});
